import { strip, yearRange } from "../lib/rosterPage";

/** A tick per year from the first show to this year, lit for the years given. */
export function Timeline({ years, first, big = false, labels = false }: { years: number[]; first: number; big?: boolean; labels?: boolean }) {
  const thisYear = new Date().getFullYear();
  const range = yearRange([{ years: [first] }], thisYear);
  return (
    <div>
      <div className={`tl ${big ? "big" : ""}`} aria-hidden="true">
        {strip(years, range).map((on, i) => (
          <i key={range[i]} className={on ? "on" : ""} />
        ))}
      </div>
      {labels && (
        <div className="tl-l">
          <span>{range[0]}</span>
          <span>{thisYear}</span>
        </div>
      )}
    </div>
  );
}
